import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
/**
 * icon 对应关系
 *
 * ams-home             首页
 * ams-assets           资产库
 * ams-media            多媒体
 * ams-borrow           资产借用归还
 * ams-distribute       资产派发退库
 * ams-inventory        资产盘点
 * ams-repair           资产维修
 * ams-setting          资产设置
 * ams-transfer         资产转移调拨
 * ams-statistics       资产统计
 * 
 * */
export var constantRoutes = [{
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/views/404');
  },
  hidden: true
}, {
  path: '/',
  component: Layout,
  name: 'index',
  meta: {
    title: '首页',
    icon: 'ams-home'
  },
  children: [{
    path: '',
    name: 'index',
    component: function component() {
      return import('@/views/index/index');
    },
    meta: {
      title: '首页',
      icon: ''
    }
  }]
}];
export var asyncRouterMap = [{
  path: '/assets',
  component: Layout,
  name: 'assets',
  meta: {
    icon: 'ams-assets',
    title: '资产',
    role: ['1', '6', '20']
  },
  children: [{
    path: 'index',
    name: 'index',
    component: function component() {
      return import('@/views/assets/index');
    },
    meta: {
      title: '资产库',
      icon: '',
      type: 0
    }
  }, {
    path: 'add',
    name: 'assetsadd',
    hidden: true,
    component: function component() {
      return import('@/views/assets/add');
    },
    meta: {
      title: '新增/编辑资产',
      icon: '',
      type: 0,
      activeMenu: '/assets/index'
    }
  }, {
    path: 'batchAddAssets',
    name: 'BatchAddAssets',
    hidden: true,
    component: function component() {
      return import('@/views/assets/batchAddAssets');
    },
    meta: {
      title: '批量添加资产',
      icon: '',
      type: 0,
      activeMenu: '/assets/index'
    }
  }]
}, {
  path: '/multimedia',
  component: Layout,
  name: 'multimedia',
  meta: {
    icon: 'ams-media',
    title: '资产套装',
    role: ['1', '6', '20']
  },
  children: [{
    path: 'list',
    name: 'multimedialist',
    component: function component() {
      return import('@/views/multimedia/list');
    },
    meta: {
      title: '资产套装管理',
      icon: '',
      type: 0,
      role: ['1', '6', '20']
    }
  }, {
    path: 'add',
    name: 'assetsadd',
    hidden: true,
    component: function component() {
      return import('@/views/multimedia/add');
    },
    meta: {
      title: '新增/编辑资产套装',
      icon: '',
      type: 0,
      activeMenu: '/multimedia/list'
    }
  }]
}, {
  path: '/statistics',
  component: Layout,
  name: 'statistics',
  meta: {
    title: '资产统计',
    icon: 'ams-statistics',
    role: ['1', '6', '20', '25'],
    roles: 'assetManageSystem'
  },
  children: [{
    path: 'whole',
    name: 'statisticswhole',
    component: function component() {
      return import('@/views/statistics/whole');
    },
    meta: {
      title: '资产概览',
      icon: '',
      type: 0,
      role: ['1', '6'],
      roles: 'assetManageSystem'
    }
  }, {
    path: 'repair',
    name: 'statisticsrepair',
    component: function component() {
      return import('@/views/statistics/repair');
    },
    meta: {
      title: '资产维修明细',
      icon: '',
      type: 0,
      role: ['1', '6', '25'],
      roles: 'assetManageSystem'
    }
  },
  // {
  //   path: 'teaassets',
  //   name: 'statisticsteaassets',
  //   component: () => import('@/views/statistics/teaassets'),
  //   meta: {
  //     title: '教职工资产统计',
  //     icon: '',
  //     type: 0
  //   }
  // },
  {
    path: 'typeposition',
    name: 'typeposition',
    component: function component() {
      return import('@/views/statistics/typeposition');
    },
    meta: {
      title: '分类与位置统计',
      icon: '',
      type: 0,
      role: ['1', '6', '20'],
      roles: 'assetManageSystem'
    }
  }, {
    path: 'groupuser',
    name: 'groupuser',
    component: function component() {
      return import('@/views/statistics/groupuser');
    },
    meta: {
      title: '部门与人员统计',
      icon: '',
      type: 0,
      role: ['1', '6'],
      roles: 'assetManageSystem'
    }
  }, {
    path: 'bidder',
    name: 'bidder',
    component: function component() {
      return import('@/views/statistics/bidder');
    },
    meta: {
      title: '资产维保到期统计',
      icon: '',
      type: 0,
      role: ['1', '6'],
      roles: 'assetManageSystem'
    }
  }]
}, {
  path: '/repair',
  component: Layout,
  name: 'repair',
  meta: {
    title: '',
    icon: 'ams-repair',
    role: ['1', '25']
  },
  children: [{
    path: 'index',
    name: 'repairindex',
    component: function component() {
      return import('@/views/repair/index');
    },
    meta: {
      title: '资产维修',
      icon: '',
      type: 0
    }
  }]
}, {
  path: '/setting',
  component: Layout,
  name: 'setting',
  meta: {
    title: '资产设置',
    icon: 'ams-setting',
    role: ['1', '6', '20']
  },
  children: [{
    path: 'sort',
    name: 'sort',
    component: function component() {
      return import('@/views/setting/sort');
    },
    meta: {
      title: '资产分类',
      icon: '',
      type: 0,
      role: ['1', '6']
    }
  }, {
    path: 'position',
    name: 'position',
    component: function component() {
      return import('@/views/setting/position');
    },
    meta: {
      title: '资产场地',
      icon: '',
      type: 0,
      role: ['1', '20']
    }
  }, {
    path: 'addposition',
    name: 'addposition',
    hidden: true,
    component: function component() {
      return import('@/views/setting/addposition');
    },
    meta: {
      title: '新增/编辑场地',
      icon: '',
      type: 0,
      activeMenu: '/setting/position'
    }
  }, {
    path: 'def',
    name: 'def',
    isLeader: true,
    component: function component() {
      return import('@/views/setting/def');
    },
    meta: {
      title: '默认资产管理',
      icon: '',
      type: 0
    }
  }]
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];
var createRouter = function createRouter() {
  return new Router({
    mode: 'history',
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;